import React from "react";
import { BiSearch } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { setSearchTerm } from "../../redux/actions/searchActions";
import { theme } from "../../utils/theme";

const SearchBar = () => {
  const dispatch = useDispatch();
  const searchTerm = useSelector(
    (state) => state.searchReducer.searchTerm || ""
  );
  const handleInputChange = (e) => {
    dispatch(setSearchTerm(e.target.value));
  };

  return (
    <div className="flex items-center rounded-md mx-6">
      <div className="flex flex-row w-full border-2 border-grey rounded-[15px]">
        <div className="p-2">
          <BiSearch className="text-xl" color="#000" />
        </div>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={handleInputChange}
          className="w-full text-xs md:text-md lg:text-xl px-2 focus:outline-none placeholder-grey bg-transparent"
          style={{ color: theme.color }}
        />
      </div>
    </div>
  );
};

export default SearchBar;
